const productName = "Dimmable Smart Bulb";
const installationInstructions = {
  intro: {
    currentStep: 'intro',
    includeInstallationSteps: false,
    includePairingProcess: false,
    isLastPage: false,
    nextStep: 'installBulb',
    nextStepName: 'instructions',
    // prevStep: N/A
    prevStepName: 'https://return-to-app',
    primaryText: `Congratulations on getting a ${productName}!`,
    resource: require('@/assets/device-models/PEX-33/pex_33.png'),
    haloDeviceResource: require('@/assets/device-models/PEX-33/pex_33_halo.png'),
    resourceType: 'image',
    secondaryText: "Let’s get started with pairing your new device",
    continueButtonText: 'Start pairing',
  },
  installBulb: {
    currentStep: 'letsGetStarted',
    isLastPage: false,
    nextStep: 'letsGetStarted',
    prevStepName: 'installationIntro', // installationIntro doesn't have a prop of :step so omit `prevStep`
    primaryText: "Installation instructions",
    secondaryText: 'Follow these simple setup instructions to install your smart bulb.',
    steps: [
      {
        title: 'Replace existing bulb',
        description: 'Turn off power to the light and allow the existing bulb to cool before unscrewing the bulb.',
        callout: 'NOTE: We do not recommend the use of standard wall dimmers with your smart bulb. Instead, you will be able to adjust the brightness of your smart bulb right from the app.',
        icon: require('@/assets/icons/lamp-black-filled.png')
      },
      {
        title: 'Install the smart bulb',
        description: 'Screw the smart bulb into the standard socket.',
        icon: require('@/assets/icons/bulb-black-filled.png')
      },
      {
        title: 'Power on your light',
        description: 'Turn on the smart bulb with your wall switch or alternate method to supply power to the light.',
        icon: require('@/assets/icons/power-black-filled.png')
      },
    ],
  },
  letsGetStarted: {
    currentStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStep: 'installBulb',
    prevStepName: 'instructions',
    resourceType: 'image',
    resource: require('@/assets/device-models/PEW-33/bulb-verify-image.png'),
    videoAutoPlay: 'autoplay',
    videoType: 'video/mp4',
    videoLoop: 'loop',
    videoControls: false,
    primaryText: 'Verify device is in pairing mode',
    secondaryText: 'Once the smart bulb is connected to power the smart bulb will blink twice to indicate it is in pairing mode.',
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      title: 'Read instructions',
    },
    continueButtonText: 'Ready',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  },
  pairingModeReset: {
    headerIcon: 'arrowGrey',
    prevStep: 'letsGetStarted',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    resourceType: 'image',
    resource: require('@/assets/device-models/PEY-33/bulb-reset-image.png'),
    resourceOverridingClass: 'background-none',
    primaryText: `Putting ${productName} into pairing mode`,
    secondaryText: `If the smart bulb did not blink twice after being connected to power, it is not in pairing mode. To manually put the ${productName} into pairing mode:`,
    steps: [
      {
        title: 'Turn bulb on/off (6 times)',
        description: 'Physically switch the smart bulb On and Off six times. Start by turning the switch Off. Turn back On for 1-2 seconds. Turn back Off for 1-2 seconds. Repeat 5 times and then turn the switch back On.',
        stepNumber: 1
      },
      {
        title: 'Blinking smart bulb',
        description: 'The smart bulb will blink twice to indicate it is in pairing mode.',
        stepNumber: 2
      },
    ],
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow'
  }
};

export default installationInstructions;
